import { fromDatetimeLocal } from './helpers';

// Convert datetime-local form values back to MySQL datetime on save.
function sanitize(values) {
  const out = { ...values };
  for (const k of Object.keys(out)) {
    let v = out[k];
    if (typeof v === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(v)) {
      v = fromDatetimeLocal(v);
    }
    // empty optional fields → NULL (keeps INT/DATE columns happy)
    out[k] = v === '' ? null : v;
  }
  return out;
}

// Build CrudModule's onSave/onDelete from API fns.
// add(payload), update({data,where}), idKey, ctx (extra add fields), userId.
export function makeCrud({ add, update, idKey, ctx = {}, userId, softDelete = true, removeFn }) {
  const onSave = (values, editing) => {
    const v = sanitize(values);
    if (editing) {
      return update({ data: { ...v, UpdatedBy: userId }, where: `${idKey} = ${editing[idKey]}` });
    }
    return add({ ...v, ...ctx, CreatedBy: userId, UpdatedBy: userId });
  };
  const onDelete = (row) => {
    if (softDelete) return update({ data: { Valid: 0, UpdatedBy: userId }, where: `${idKey} = ${row[idKey]}` });
    return removeFn({ where: `${idKey} = ${row[idKey]}` });
  };
  return { onSave, onDelete };
}
